export default "__VITE_ASSET__DMo$KL0z__"